import { useIsDarkMode } from './useIsDarkMode';
export const useThemeBackground = () => {
  const isDarkMode = useIsDarkMode();
  return {
    shell: isDarkMode ? 'fill-surface-default' : 'fill-surface-recessed',
    mainContentArea: isDarkMode ? 'fill-surface-recessed' : 'fill-surface-default'
  };
};